import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsStore } from '@app/core/state/app-settings-store/app-settings-store';
import { DocumentDetailsDTO } from '@modules/registered-document-manager/models';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentContentSearchAddSaveService {
    private apiUrl = environment.apiRoot;

    constructor(private http: HttpClient, private appSettingsStore: AppSettingsStore) {}

    /**
     * POSTs all new detail rows in one batch.
     */
    saveDetails(dtos: DocumentDetailsDTO[]): Observable<any> {
        const headers = new HttpHeaders()
            .set('X-ClientId', this.appSettingsStore.settings()?.user?.id || '')
            .set('X-User', this.appSettingsStore.settings()?.user?.name || '');

        return this.http.post<any>(`${this.apiUrl}register-detail`, dtos, { headers });
    }

    getDocumentContentSearchAddSave$(): Observable<{}> {
        return of({});
    }
}
